export default __webpack_public_path__ + "static/flybus_Icelandair_Banner-fdf423fe40e483de5808402200b2a2b3.jpg";